var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourtIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.008,464H304v-16c0-26.469-21.531-48-48-48H64c-26.461,0-48,21.531-48.008,48v16.002C7.161,464.006,0,471.167,0,480   c0,8.836,7.164,16,16,16h288.008c8.836,0,16-7.164,16-16S312.844,464,304.008,464z M64,432h192c8.82,0,16,7.18,16,16v16H47.992   v-15.992C48,439.18,55.18,432,64,432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,128H224V96h16c8.836,0,16-7.164,16-16V32c0-8.836-7.164-16-16-16H80c-8.836,0-16,7.164-16,16v48   c0,8.836,7.164,16,16,16h16v160.001L80,256c-4.242,0-8.313,1.688-11.313,4.688S64,267.758,64,272v47.992   C64,328.828,71.164,336,80,336h160c4.242,0,8.313-1.688,11.313-4.688S256,324.242,256,320v-47.992c0-8.836-7.164-16-16-16   l-16-0.001V224h240c26.469,0,48-21.531,48-48C512,149.531,490.469,128,464,128z M224,304H96v-16l128,0.008V304z M96,48h128v16h-16   h-96H96V48z M192,96v48v64v48h-64V96H192z M464,192H224v-32h240c8.82,0,16,7.18,16,16S472.82,192,464,192z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtIcon);
export default __webpack_public_path__ + "static/media/court-icon.8834ea38.svg";
export { ForwardRef as ReactComponent };